export default {
	editEventDate: "Editar fecha de entrada o salida",
	becomeMedium: "Convertir en Médium",
	leaveMedium: "Desligar Médium",
	becomeMediumTitle: "Convertir en Médium",
	leaveMediumTitle: "Salir de la Corriente",
	becomeMediumConfirm: "Confirmar entrada en la corriente",
	leaveMediumConfirm: "Confirmar salida de la corriente",
	entryEvent: "Entrada en la Corriente",
	exitEvent: "Salida de la Corriente",
	date: "Fecha",
	reason: "Motivo",
	notes: "Observaciones",
	entryDate: "Fecha de entrada en la corriente",
	entryNotes: "Observaciones de la entrada",
	personSource: {
		existing: "Ya registrada",
		new: "Registrar nueva",
	},
	reasons: {
		voluntary: "Alejamiento voluntario",
		disciplinary: "Alejamiento disciplinario",
		transfer: "Cambio de templo",
		other: "Otros",
	},
	leaveMediumWarning: "Esta acción también desactivará todas las jornadas activas de esta persona.",
	success: {
		entry: "La persona ahora es médium de la corriente",
		exit: "Persona desligada de la corriente",
	},
	timeline: {
		title: "Historial",
		empty: "No se encontraron registros",
		by: "por",
	},
};
